import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useBrandContext } from '../../context/BrandContext';
import { useAuth } from '../../context/AuthContext';
import { ReactComponent as LoaderSecondary } from '../../assets/SpinnerBlack.svg';
import api from '../../axios/axiosConfig';
import couponIcon from '../../assets/icon_coupon.png';
import {
  TabHeader,
  TabBody,
  TabBodyEmpty,
  TabHeaderItemProps,
} from '../../components/tabs/tabs';
import {
  CardCupomDetails,
  CardCupomDetailsData,
} from '../../components/cardCuponDetails/CardCupomDetails';
import Modal from '../../components/modal/Modal';
import SwipeToRefresh from '../../components/SwipeToRefresh/SwipeToRefresh';
import { useHeaderContext } from '../../context/HeaderContext';
import HeaderBasicLayout from '../../components/header/headerBasicLayout/HeaderBasicLayout';

export const cuponErrorMsgMap: { [key: string]: string } = {
  DISCOUNT_COUPON_NOTFOUND: 'Código inválido.',
  DISCOUNT_COUPON_APPID_INVALID: 'Código inválido.', // Quando o cupom não pertence a Brand que o usuário está
  DISCOUNT_COUPON_INACTIVE: 'Código inválido.', // Quando o cupom não está ativo
  ERR_USERDISCOUNTCOUPON_INVALID: 'Código inválido.', // Passou um id aleatorio
  ERR_DISCOUNTCOUPON_INACTIVE: 'Código inválido.', // cupom inativo
  DISCOUNTCOUPON_INVALID: 'Cupom inválido',
};

const Coupons = ({
  fromRechargeStart,
  setCouponScreenActive,
  handleCouponSelect,
  chargerSiteId,
  chargerSiteName,
}: {
  fromRechargeStart?: boolean;
  setCouponScreenActive?: (value: boolean) => void;
  handleCouponSelect?: (value: {}) => void;
  chargerSiteId?: any;
  chargerSiteName?: string;
}) => {
  const navigate = useNavigate();
  const brandContext = useBrandContext();
  const authContext = useAuth();
  const { setHeaderConfig } = useHeaderContext();

  const [activeTab, setActiveTab] = useState<string>('active');
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [cupomListData, setCupomListData] = useState<any[]>([]);
  const [newCouponCode, setNewCouponCode] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
  const [titleErrorModal, setTitleErrorModal] = useState<string>('');
  const [textErrorModal, setTextErrorModal] = useState<string>('');
  const [isActiveRulesModalOpen, setIsActiveRulesModalOpen] =
    useState<boolean>(false);
  const [currentItemRule, setCurrentItemRule] = useState<any>();

  const tabHeaderItems: TabHeaderItemProps[] = [
    { id: 'active', text: 'Ativos' },
    { id: 'inactive', text: 'Indisponíveis' },
  ];

  const getCouponList = async () => {
    setIsLoading(true);
    try {
      const response = await api.get(`/UserDiscountCoupon`, {
        params: {
          status: activeTab,
          page: 1,
          pageSize: 1000,
          search: '',
          dcType: '',
          verifySiteId: chargerSiteId,
        },
      });
      setCupomListData(response.data.items);
    } catch (error: any) {
      console.error(error);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 250);
    }
  };

  const handleAddCoupon = async () => {
    if (!newCouponCode.trim()) return;
    setIsSubmitting(true);
    try {
      await api.post(
        `/UserDiscountCoupon/AddDiscountCoupon/${newCouponCode.trim()}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${authContext.token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      setNewCouponCode('');
      getCouponList();
    } catch (error: any) {
      console.error('Erro ao adicionar cupom:', error.response.data.error);
      setTitleErrorModal(cuponErrorMsgMap[error.response.data.error]);
      setTextErrorModal('Verifique se digitou corretamente o código do cupom.');
      setShowErrorModal(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleTabClick = (tabId: string) => {
    setIsLoading(true);
    setActiveTab(tabId);
  };

  const handleIsActiveRulesModalOpen = (data: any) => {
    setCurrentItemRule(data);
    setIsActiveRulesModalOpen(true);
  };

  const renderRules = () => {
    const {
      dcCode,
      dcParameter,
      dcType,
      applicationName,
      dcValidTo,
      dcTimeFrameFrom,
      dcTimeFrameTo,
      dcOnlyAboveValue,
      availableSite,
      udcRemainingValue,
      dcSelectedSites,
    } = currentItemRule || {};
    const formatTimeToLocalHHmm = (timeString: string) => {
      if (!timeString) return '';
      const [hours, minutes, seconds] = timeString.split(':').map(Number);
      const now = new Date();
      const utcDate = new Date(
        Date.UTC(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          hours,
          minutes,
          seconds || 0
        )
      );
      const localHours = String(utcDate.getHours()).padStart(2, '0');
      const localMinutes = String(utcDate.getMinutes()).padStart(2, '0');
      return `${localHours}:${localMinutes}`;
    };
    const formatDate = (dateString: string | null) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      const dia = String(date.getDate()).padStart(2, '0');
      const mes = String(date.getMonth() + 1).padStart(2, '0');
      const ano = date.getFullYear();
      const horas = String(date.getHours()).padStart(2, '0');
      const minutos = String(date.getMinutes()).padStart(2, '0');
      return `${dia}/${mes}/${ano} às ${horas}:${minutos}`;
    };
    const percentTypes: string[] = ['DiscountCoupon', 'SalesCoupon'];

    const valueTypes: string[] = ['ValueOfVoucher'];
    return (
      <>
        <div className='coupon-card-header'>
          <h3 className='coupon-card-title'>{dcCode}</h3>
        </div>
        <p
          className='coupon-card-description'
          style={{ marginBottom: 0, fontSize: 14 }}
        >
          Desconto de
          {valueTypes.includes(dcType) && ' R$'}
          {` ${dcParameter}`}
          {valueTypes.includes(dcType) && ' '}
          {percentTypes.includes(dcType) && '% '}
          em recargas
        </p>
        {udcRemainingValue !== null && udcRemainingValue !== undefined ? (
          <p
            className='coupon-card-description'
            style={{ marginBottom: 12, fontSize: 14 }}
          >
            Valor restante de R${' '}
            {new Intl.NumberFormat('pt', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(udcRemainingValue)}
          </p>
        ) : null}
        {dcSelectedSites && dcSelectedSites.length && (
          <>
            <div
              className='coupon-card-rule-item'
              style={{ fontSize: 12, marginBottom: 2 }}
            >
              Sites válidos:
            </div>
            <div className='coupon-card-rule-item' style={{ marginBottom: 10 }}>
              {dcSelectedSites
                .map((site: any) => site.name)
                .map((name: string, index: number, arr: string[]) => {
                  if (index === 0) return name;
                  if (index === arr.length - 1) return ` e ${name}`;
                  return `, ${name}`;
                })}
            </div>
          </>
        )}
        <div className='coupon-card-rules-list' style={{ display: 'block' }}>
          <div className='coupon-card-rule-item'>
            ⦁ Válido nos pontos de recarga {applicationName}
          </div>
          {dcTimeFrameFrom && (
            <div className='coupon-card-rule-item'>
              ⦁ Entre {formatTimeToLocalHHmm(dcTimeFrameFrom)} e{' '}
              {formatTimeToLocalHHmm(dcTimeFrameTo)}
            </div>
          )}
          {dcOnlyAboveValue && (
            <div className='coupon-card-rule-item'>
              ⦁ Recargas acima de R${' '}
              {new Intl.NumberFormat('pt', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(dcOnlyAboveValue)}
            </div>
          )}
          {dcValidTo && (
            <div className='coupon-card-rule-item'>
              ⦁ Válido até {formatDate(dcValidTo)}
            </div>
          )}
          {!availableSite && (
            <div className='coupon-card-rule-item'>
              ⦁ Não válido no local {chargerSiteName}
            </div>
          )}
        </div>
      </>
    );
  };

  useEffect(() => {
    getCouponList();
  }, [activeTab]);

  useEffect(() => {
    setHeaderConfig({
      headerText: 'Cupons',
      backNavigation: () =>
        fromRechargeStart && setCouponScreenActive
          ? setCouponScreenActive(false)
          : navigate(`/${brandContext.brandName}/userProfile`),
      closeNavigation: () =>
        fromRechargeStart && setCouponScreenActive
          ? setCouponScreenActive(false)
          : navigate(`/${brandContext.brandName}`),
    });
    return () => setHeaderConfig({});
  }, [
    brandContext.brandName,
    fromRechargeStart,
    navigate,
    setCouponScreenActive,
    setHeaderConfig,
  ]);

  return (
    <>
      {fromRechargeStart && (
        <div
          style={{
            backgroundColor: brandContext.brandBgColor,
            position: 'relative',
            zIndex: 2,
          }}
          className={`header-main-container`}
        >
          <HeaderBasicLayout
            headerText={'Cupons'}
            showLogo={false}
            showActionButtons={true}
            backNavigation={() =>
              fromRechargeStart && setCouponScreenActive
                ? setCouponScreenActive(false)
                : navigate(`/${brandContext.brandName}/userProfile`)
            }
            closeNavigation={() =>
              fromRechargeStart && setCouponScreenActive
                ? setCouponScreenActive(false)
                : navigate(`/${brandContext.brandName}`)
            }
          />
        </div>
      )}
      <SwipeToRefresh onSwipeDown={getCouponList}>
        <div style={{ marginTop: '10px' }}>
          <div style={{ padding: '15px' }}>
            <TabHeader
              items={tabHeaderItems}
              activeId={activeTab}
              onTabClick={handleTabClick}
            />
            {activeTab === 'active' && (
              <div className='tab-coupon-form'>
                <input
                  type='text'
                  placeholder='Código do cupom'
                  className='coupon-input'
                  value={newCouponCode}
                  onChange={(e) => setNewCouponCode(e.target.value)}
                  disabled={isSubmitting}
                />
                <button
                  className='coupon-button'
                  onClick={handleAddCoupon}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Validando...' : 'Adicionar'}
                </button>
              </div>
            )}
            {isLoading ? (
              <div style={{ margin: 'auto', marginTop: '20px' }}>
                <LoaderSecondary className='spinner' />
              </div>
            ) : (
              <div className='tab-content' style={{ marginTop: 10 }}>
                <TabBodyItem
                  tabId='active'
                  activeTab={activeTab}
                  cupomListData={cupomListData}
                  emptyIcon={couponIcon}
                  emptyTitle='Nenhum Cupom Disponível'
                  emptyText='Ao inserir um novo código de cupom de desconto, ele irá aparecer aqui.'
                  fromRechargeStart={fromRechargeStart}
                  handleCouponSelect={handleCouponSelect}
                  handleIsActiveRulesModalOpen={handleIsActiveRulesModalOpen}
                />
                <div style={{ opacity: 0.75 }}>
                  <TabBodyItem
                    tabId='inactive'
                    activeTab={activeTab}
                    cupomListData={cupomListData}
                    emptyIcon={couponIcon}
                    emptyTitle='Nenhum Cupom Inativo'
                    emptyText='Seus cupons expirados irão aparecer aqui.'
                    fromRechargeStart={fromRechargeStart}
                    handleCouponSelect={handleCouponSelect}
                    handleIsActiveRulesModalOpen={handleIsActiveRulesModalOpen}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </SwipeToRefresh>
      <Modal
        allowButtonClosed={true}
        isOpen={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        title={titleErrorModal}
        styleEnterButton={{
          backgroundColor: brandContext.brandBgColor,
          border: 'none',
        }}
        textEnterButton='OK, entendi'
        handleEnterButton={() => setShowErrorModal(false)}
        isLoadingEnterButton={isLoading}
      >
        <p>{textErrorModal}</p>
      </Modal>
      <Modal
        allowButtonClosed={false}
        isOpen={isActiveRulesModalOpen}
        onClose={() => {
          setIsActiveRulesModalOpen(false);
        }}
        textEnterButton=''
        handleEnterButton={() => {}}
        isLoadingEnterButton={false}
        styleEnterButton={{ backgroundColor: `${brandContext.brandBgColor}` }}
        disableEnterButton={true}
        modalBackdrop={true}
        header={false}
      >
        <div className='group-list' style={{ marginTop: 10 }}>
          {renderRules()}
        </div>
      </Modal>
    </>
  );
};

interface TabBodyItemProps {
  tabId: string;
  activeTab: string;
  cupomListData: any;
  emptyIcon: string;
  emptyTitle: string;
  handleIsActiveRulesModalOpen: (value: any) => void;
  emptyText: string;
  fromRechargeStart?: boolean;
  handleCouponSelect?: (value: {}) => void;
}

const TabBodyItem = ({
  tabId,
  activeTab,
  cupomListData,
  emptyIcon,
  emptyTitle,
  emptyText,
  handleIsActiveRulesModalOpen,
  fromRechargeStart,
  handleCouponSelect,
}: TabBodyItemProps) => (
  <TabBody tabId={tabId} activeId={activeTab}>
    {cupomListData.length > 0 ? (
      cupomListData.map((item: CardCupomDetailsData) => {
        return (
          <CardCupomDetails
            key={item.dcId}
            data={item}
            onClick={
              fromRechargeStart && tabId === 'active'
                ? handleCouponSelect
                : undefined
            }
            setIsActiveRulesModalOpen={handleIsActiveRulesModalOpen}
          />
        );
      })
    ) : (
      <TabBodyEmpty icon={emptyIcon} title={emptyTitle} text={emptyText} />
    )}
  </TabBody>
);
export default Coupons;
